import { useRef } from 'react';
import type { ReelDraft } from '@/lib/reel';
import { effectiveClips, type ReelClip } from '@/lib/reel-sequence';
export function ReelClips({
  draft,
  selected,
  onSelect,
  onAdd,
  onClips,
  statuses,
  onRetry,
  disabled,
}: {
  draft: ReelDraft;
  selected: string;
  onSelect: (id: string) => void;
  onAdd: (files: File[]) => void;
  onClips: (clips: ReelClip[]) => void;
  statuses: Record<string, string>;
  onRetry: (id: string) => void;
  disabled: boolean;
}) {
  const input = useRef<HTMLInputElement>(null),
    clips = effectiveClips(draft);
  const index = clips.findIndex((c) => c.id === selected);
  const move = (delta: number) => {
    const next = [...clips];
    [next[index], next[index + delta]] = [next[index + delta]!, next[index]!];
    onClips(next);
  };
  return (
    <fieldset className="picture-tools" disabled={disabled}>
      <div className="reel-clip-strip" aria-label="Reel clips">
        {clips.map((clip, i) => (
          <div key={clip.id} className="reel-clip">
            <button
              type="button"
              className="chip hv"
              aria-pressed={selected === clip.id}
              onClick={() => onSelect(clip.id)}
            >
              {i + 1}.{' '}
              {draft.clipInfo?.[clip.id]?.name ??
                (clip.source.kind === 'original' ? 'Original' : 'Clip')}
              <br />
              {((clip.trim.endMs - clip.trim.startMs) / 1000).toFixed(1)}s
            </button>
            {statuses[clip.id] && <span role="status">{statuses[clip.id]}</span>}
            {statuses[clip.id]?.startsWith('Upload failed') && (
              <button className="chip hv" type="button" onClick={() => onRetry(clip.id)}>
                Retry upload
              </button>
            )}
          </div>
        ))}
      </div>
      <div className="picture-row">
        <button
          className="chip hv"
          type="button"
          disabled={clips.length >= 10}
          onClick={() => input.current?.click()}
        >
          Add clips
        </button>
        <input
          ref={input}
          hidden
          type="file"
          accept="video/mp4"
          multiple
          aria-label="Add clips"
          onChange={(e) => {
            onAdd(Array.from(e.target.files ?? []));
            e.target.value = '';
          }}
        />
        <button className="chip hv" type="button" disabled={index <= 0} onClick={() => move(-1)}>
          Earlier
        </button>
        <button
          className="chip hv"
          type="button"
          disabled={index < 0 || index === clips.length - 1}
          onClick={() => move(1)}
        >
          Later
        </button>
        <button
          className="chip hv"
          type="button"
          disabled={clips.length <= 1}
          onClick={() => onClips(clips.filter((c) => c.id !== selected))}
        >
          Remove clip
        </button>
      </div>
    </fieldset>
  );
}
